import { keyBy } from 'lodash-es';
import { QueryResult } from '@/api/queries/useQuery';
import { CubeRawRow } from '@/utils/cube/mapper.type';

export function mergeDateRangeCompareRecordByDimension(
  dimension: string,
  resultSet1: CubeRawRow[],
  resultSet2: CubeRawRow[],
  previousPeriodString: string,
): CubeRawRow[] {
  const result1Map = keyBy(resultSet1, dimension);
  const result2Map = keyBy(resultSet2, dimension);

  return Object.keys(result1Map).map(key => {
    const currentRecord = result1Map[key];
    const previousRecord = result2Map[key] || {};

    const mergedRecord = { ...currentRecord };

    Object.keys(previousRecord).forEach(prevKey => {
      if (prevKey !== dimension && prevKey !== 'compareDateRange') {
        const newKey = `${previousPeriodString},${prevKey}`;
        mergedRecord[newKey] = previousRecord[prevKey];
      }
    });

    return mergedRecord;
  });
}

export function transformResult(result: QueryResult, preserveNulls = false): CubeRawRow[] {
  if (preserveNulls) {
    return result.rawData();
  }
  return result.tablePivot();
}

export function processDecomposedResults(
  results: QueryResult[],
  mergeDimension?: string,
  preserveNulls = false,
): unknown[] {
  const [result1, result2] = results.map(r => transformResult(r, preserveNulls));

  if (mergeDimension) {
    const previousPeriodString = results[1].loadResponses?.[0]?.data[0]?.compareDateRange;
    return mergeDateRangeCompareRecordByDimension(mergeDimension, result1, result2, previousPeriodString);
  }

  return results.flatMap(r => transformResult(r, preserveNulls));
}

export const isStringArray = (data: unknown): data is string[] =>
  Array.isArray(data) && data.every(itemToCheck => typeof itemToCheck === 'string');

export const isNonEmptyString = (input: unknown): input is string => typeof input === 'string' && input.length > 0;
